const getSelectorByGlobalId = (variablesArr, globalId) =>
  variablesArr.reduce(
    (selector, variable) => (variable.globalId === globalId ? variable.querySelector : selector),
    null
  );

export default getSelectorByGlobalId;
